import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@ui-kitten/components'
import { SelectIconButtonGroup } from './SelectIconButtonGroup'

export const PurchaseMethodsSelect = React.memo(function PurchaseMethodsSelect(props) {
  const { t } = useTranslation()
  const filteredMethods = React.useMemo(() => {
    return props.purchaseMethods?.filter(item => item.activeInStore?.[props.store]) || []
  }, [props.purchaseMethods, props.store])

  if (filteredMethods.length === 0) {
    return (
      <Text status='warning'>
        ⚠️ {t('newSale.noPurchaseMethodsForStore')}
      </Text>
    )
  }

  return (
    <SelectIconButtonGroup
      items={filteredMethods}
      selectedItem={props.purchaseMethod}
      onItemSelect={props.setPurchaseMethod}
      testIDPrefix="purchase-method"
    />
  )
}, function(prev, next) {
  if (prev.purchaseMethod?.id !== next.purchaseMethod?.id) {
    return false
  }
  if (prev.purchaseMethods == null) {
    return false
  }
  if (prev.store !== next.store) {
    return false
  }
  return true
})
